<template>
  <div
    v-if="isReadOnly"
    class="inline-block"
  >
    <rv-chip
      background-color="white"
      bordered
      data-automation="readonly-chip"
      :label="$t('general.text.readOnly')"
      text-color="info"
    />

    <rv-tooltip data-automation="readonly-chip__tooltip">
      {{ $t('general.text.readOnlyDescription', [algorithmNameWithVersion]) }}
    </rv-tooltip>
  </div>
</template>

<script lang="ts" setup>
import {
  computed,
  type PropType,
} from 'vue'
import type { Project } from '~domain/projects/Project'
import { useProjectsStore } from '~stores/projectsStore/useProjectsStore'


const props = defineProps({
  isReadOnly: {
    default: false,
    type: Boolean,
  },
  project: {
    required: true,
    type: Object as PropType<Project>,
  },
})

const {
  getAlgorithmNameWithVersion,
  isProjectReadOnly,
} = useProjectsStore()

const algorithmNameWithVersion = computed(() => getAlgorithmNameWithVersion(props.project))
const isReadOnly = computed(() => props.isReadOnly || isProjectReadOnly(props.project))
</script>
